import Icon from '@ant-design/icons';
import { CustomIconComponentProps } from '@ant-design/icons/lib/components/Icon';

import { NutritionSvg } from './svg/nutrition';

export const NutritionIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={NutritionSvg} {...props} />
);
